/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { Button, Col, Row, Label, FormGroup, Collapse } from 'reactstrap'
import { Form } from 'formik'
import Select from 'react-select'
import { STYLES_REACT_SELECT_NEW_WITH_INSET_SHADOW } from '../../../constants'
import { I18n } from 'react-redux-i18n'
import TextInputField from 'components/Form/TextInputField'
import { PhoneInput, SelectWithLabel } from 'components/Form'
import FileUploader from '../../ChannelView/Channels/fields/FileUploader'
import { getStaticImage } from 'utils/statics'
import Attachment from 'components/Chat/Attachment'
import es from 'react-phone-input-2/lang/es.json'
import { toast } from 'react-toastify'

import { marketingAct } from '../../../redux/actions'
import { MARKETING, TEMPLATE_WHATSAPP } from '../../../constants'
import PhoneViewer from 'components/PhoneViewer'
import TextEditor2 from 'components/Form/TextEditor/TextEditor2'
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd'
import ModalPublishedWATemplate from './ModalPublishedWATemplate'
import ModalWrapper from 'components/ModalWrapper'
import { addChannelsTemplate, getTemplate } from 'api/marketing/templates'
import TemplateChannels from './TemplateChannels'
import Nixi1Spinner from 'components/Nixi1Spinner'
import { lang } from 'utils/helpers'
import ModalVirusAttachments from 'components/common/ModalVirusAttachments'
import { verifyFileVirus } from 'utils/FileUtils'
const _ = require('lodash')

/*
  Estados para editar
  prevStatus_status
*/
const statusPublish = {
  DRAFT_DRAFT : true,
  APPROVED_APPROVED:false,
  APPROVED_DRAFT: true,
  PENDING_DRAFT: true,
  REJECTED_DRAFT: true,
  PAUSED_DRAFT: true,

}

const statusEdit = {
  DRAFT : true,
  APPROVED :true,
  PENDING: true,
  REJECTED: true,
  PAUSED: true,
}

const STATUS_NOT_PUBLISH = ['APPROVED', 'PENDING']

function needPublishTemplate(params) {
  const { channels, template } = params

  if (!Array.isArray(channels) || !channels.length) return false

  if (template?.status && template.status === 'DRAFT') return true

  if (channels.some(e => e.isEnabled && !STATUS_NOT_PUBLISH.includes(e.status))) {
    return true
  }

  return false
}

const getBtnFile = (acceptFiles, channel, attachmentHeader, setAttachmentHeader, setErrorTemplate) =>{
  return(
    <FileUploader
      key={acceptFiles}
      channel={channel}
      label=''
      required={false}
      acceptTypes={acceptFiles}
      value={attachmentHeader || ''}
      prop={"app.logo"}
      propName={'app_logo'}
      isOpenContainer={{ configuration: false, messages: false, resources: true }}
      onChange={(value)=>{
        setAttachmentHeader(value)
        setErrorTemplate({ attachmentHeader:'' })
      }}
      restore={true}
      description=''
      className='button-template'
      imgUploadIcon = '/icons/upload-white.svg'
      previewFile={false}
    />
  )
}

const FormWhatsappCloudApi = ({ template = null, isChat, company, acceptTypes, channel, setForm, setFormEdit }) => {
  const { variables } = useSelector((store) => store.marketing.templates)
  const dispatch = useDispatch()

  const [ btnFile, setBtnFile ] = useState(null)
  const [ languageTemplateOptions ] = useState(TEMPLATE_WHATSAPP.languageTemplates.map(it=> ({ ...it, label:I18n.t(it.label) })))
  const [ headerTemplateOptions ] = useState(TEMPLATE_WHATSAPP.headerTemplates.map(it=> ({ ...it, label:I18n.t(it.label) })))
  const [ buttonsTemplateOptions ] = useState(TEMPLATE_WHATSAPP.buttonsTemplates.map(it=> ({ ...it, label:I18n.t(it.label) })))
  const [ btnCallToActionOptions ] = useState(TEMPLATE_WHATSAPP.buttonsCallToActionTemplates.map(it=> ({ ...it, label:I18n.t(it.label) })))

  const [ isOpenAlert, setIsOpenAlert] = useState(true)
  const [errorTemplate, setErrorTemplate] = useState({})
  const [ nameTemplate, setNameTemplate] = useState('')
  const [ footerTemplate, setFooterTemplate] = useState('')
  const [ nameHeaderTemplate, setNameHeaderTemplate] = useState('')
  const [ languageTemplateValue, setLanguageTemplateValue ] = useState(languageTemplateOptions[0])
  const [ headerTemplateValue, setHeaderTemplateValue ] = useState(headerTemplateOptions[0])
  const [ buttonsTemplateValue, setbuttonsTemplateValue ] = useState([buttonsTemplateOptions[0]])
  const [ btnCallToActionOptionsValue, setBtnCallToActionOptionsValue ] = useState([btnCallToActionOptions[0]])
  const [ attachmentHeader, setAttachmentHeader ] = useState(null)
  const [ varHeader, setVarHeader ] = useState(null)
  const [ varBody, setVarBody ] = useState([])
  const [ contentBody, setContentBody ] = useState({})
  const [ btnQuickReply, setBtnQuickReply ] = useState([])
  const [ btnCallToAction, setBtnCallToAction ] = useState([{ type:btnCallToActionOptions[0] }])
  const [ isLoading, setIsLoading ] = useState(false)
  const [ isLoadingReview, setIsLoadingReview ] = useState(false)
  const [ publishTemplate, setPublishTemplate ] = useState(false)
  const [ templateReview, setTemplateReview ] = useState(null)
  const [ modalPublishedTemplate, setModalPublishedTemplate ] = useState(false)
  const [ modalPublishMessage, setModalPublishMessage ] = useState(null)
  const [isOpenPreviewModal, setIsOpenPreviewModal] = useState(false)
  const [templateChannels, setTemplateChannels] = useState([])
  const [isLoadingTemplateChannels, setIsLoadingTemplateChannels] = useState(false)
  const [disabledEdit, setDisabledEdit] = useState(false)

  useEffect(() => {
    if (template?._id) {
      getTemplateChannels(template._id)
    }
  }, [template?._id])

  useEffect(() => {
    if (template !== null) {
      setTemplateReview(template)

      getLanguageEdit()

      setNameTemplate(template.name)

      getHeaderEdit()

      const numbersFromContent = getNumbersFromContent(template?.content || '')
      setContentBody({ value: { content: template.content, variablesEditor: numbersFromContent } })

      if (template?.variables?.length) {
        setVarBody(template.variables.map(e => ({ name: e.name, field: e.field })))
      }

      setFooterTemplate(template.footer?.content || '')

      getButtonsEdit()
    }
  }, [template])

  const getTemplateChannels = (templateId) => {
    setIsLoadingTemplateChannels(true)

    getTemplate(templateId)
      .then(({ data }) => {
        setTemplateChannels(data.channels)
        setDisabledEdit(!data.allowedToEdit)
        setPublishTemplate(
          needPublishTemplate({ ...data })
        )
      })
      .catch(error => console.error(error))
      .finally(() => setIsLoadingTemplateChannels(false))
  }

  const getLanguageEdit = () => {
    const languageTemplate = languageTemplateOptions.find((l) => l.value === template.locale.content)
    setLanguageTemplateValue({
      label: I18n.t(languageTemplate?.label|| languageTemplateOptions[0].label),
      value: languageTemplate?.value || languageTemplateOptions[0].value
    })
  }

  const getHeaderEdit = () => {
    const headerFormat = headerTemplateOptions.find((format) => template.header.format === format?.value?.toUpperCase())
    setHeaderTemplateValue(headerFormat ? headerFormat : headerTemplateOptions[0])
    setNameHeaderTemplate(template.header?.content || '')
    const variableHeader = varsOptions.find((v)=>template.header?.variable?.field === v?.value)
    const numbersFromContent = getNumbersFromContent(template.header?.content || '')
    if(numbersFromContent.length === 1 ){
      const newContent = `{{${numbersFromContent.length}}}`
      setVarHeader({ ...variableHeader, index:numbersFromContent[0], input:newContent, field:variableHeader?.value })
    }
    if(template.header.type === 'media'){
      setBtnFile(getBtnFile(TEMPLATE_WHATSAPP.acceptTypesFile[headerFormat.value], channel, template.attachments, setAttachmentHeader, setErrorTemplate))
      setAttachmentHeader(template.attachments)
    }
  }

  const getSelectVariableValueByIndex = (varOptions, field, template) => {
    if (!varOptions || !varOptions.length) return

    const v = varOptions.find((v) => v.value === field)
    if (!v) return

    return v
  }

  const getButtonsEdit = () => {
    const btnTemplate = template.buttons.some((btn) => btn.type === 'postback')
    const type = btnTemplate ? 'quick_reply': template.buttons.length > 0 ? 'call_to_action' : 'none'
    const btnOptions = buttonsTemplateOptions.find((btnOp) => btnOp.value === type)
    setbuttonsTemplateValue(btnOptions)

    if(type === 'call_to_action'){
      const callToAct = []
      for (let btnTemplate of template.buttons){
        const typeBtn = btnCallToActionOptions.find((btn) => btn.value === btnTemplate.type)
        callToAct.push({ type: typeBtn, [btnTemplate.type]:btnTemplate.content, textBtn:btnTemplate.label })
      }
      setBtnCallToAction(callToAct)
    }
    if(type === 'quick_reply'){
      const quickReply = []
      for (let btnTemplate of template.buttons)
        quickReply.push(btnTemplate.label || '')
      setBtnQuickReply(quickReply)
    }
  }
  const varsOptions = (variables || [])
    .map((elem) => ({
      value: elem.value,
      label: I18n.t(elem.label),
    }))
    .concat(isChat ? { value: '', label: I18n.t('dashboard_free-text') } : [])

  const onChange = (value, option) => {
    if(option === 'language')
      setLanguageTemplateValue(value)

    if(option === 'headerTemplate') {
      setHeaderTemplateValue(value)
      setAttachmentHeader(null)
      setNameHeaderTemplate('')
      setVarHeader(null)
      setBtnFile(
        getBtnFile(TEMPLATE_WHATSAPP.acceptTypesFile[value.value], channel, attachmentHeader, setAttachmentHeader, setErrorTemplate)
      )
    }

    if( option === 'buttonsTemplate'){
      setbuttonsTemplateValue(value)
      if(value === 'quick_reply'){
        btnQuickReply.push('')
        setBtnQuickReply([...btnQuickReply])
      }
      if(value === 'call_to_action'){
        btnCallToAction.push({})
        setBtnCallToAction([...btnCallToAction])
      }
    }

    if (publishTemplate) setPublishTemplate(false)
  }

  const onChangeHeaderTemplate = (value) => {
    const contentVar = getNumbersFromContent(value)
    if(!contentVar.length) setVarHeader(null)
    setNameHeaderTemplate(value)
    setErrorTemplate({ nameHeaderTemplate:'' })

    if (publishTemplate) setPublishTemplate(false)
  }

  const onChangeBody = (data) => {
    setContentBody(data)
    setErrorTemplate({ contentBody:'' })

    if (publishTemplate) setPublishTemplate(false)
  }

  const getNumbersFromContent = (content = '') => ((content.match(/{{[0-9]+}}/g) || []).map((x) => x.match(/[0-9]+/)))

  const onClickVariable = () => {
    const numbersFromContent = getNumbersFromContent(nameHeaderTemplate)
    const index = numbersFromContent.length > 0 ? numbersFromContent.length + 1 : 1
    if(index <= 1){
      const newContent = `{{${index}}}`
      setNameHeaderTemplate(`${nameHeaderTemplate} ${newContent}`)
      setVarHeader({ index, input: newContent, name: newContent })
      setErrorTemplate({ contentBody:'' })
    }

    if (publishTemplate) setPublishTemplate(false)
  }

  const handleVariableOnChangeHeader = (value) => {
    setVarHeader({ ...varHeader, field: value.value })
    setErrorTemplate({ varHeader:'' })

    if (publishTemplate) setPublishTemplate(false)
  }

  const handleVariableOnChange = (value, variablesName, index) => {
    varBody[index] = { name: variablesName.input, field: value.value }

    setVarBody([...varBody])
    setErrorTemplate({ varBody:'' })

    if (publishTemplate) setPublishTemplate(false)
  }

  const newButtonQuickReply = () => {
    if(btnQuickReply.length < 3) {
      btnQuickReply.push('')
      setBtnQuickReply([...btnQuickReply])

      if (publishTemplate) setPublishTemplate(false)
    }

  }

  const newButtonCallToAction = () => {
    if(btnCallToAction.length < 2) {
      for( let [index, buttonCallToActionTemplate] of TEMPLATE_WHATSAPP.buttonsCallToActionTemplates.entries()){
        if(btnCallToAction[0].type.value !== buttonCallToActionTemplate.value){
          setBtnCallToActionOptionsValue(buttonCallToActionTemplate)
          // TEMPLATE_WHATSAPP.buttonsCallToActionTemplates.splice(index, 1)
          btnCallToAction.push({ type:btnCallToActionOptions[index] })
        }
      }
      setBtnCallToAction([...btnCallToAction])

      if (publishTemplate) setPublishTemplate(false)
    }
  }

  const resetBtnQuick = ( index ) => {
    btnQuickReply.splice(index, 1)
    setBtnQuickReply([...btnQuickReply])

    if (publishTemplate) setPublishTemplate(false)
  }

  const resetBtnCallToAction = ( index )=> {
    btnCallToAction.splice(index, 1)
    setBtnCallToAction([...btnCallToAction])

    if (publishTemplate) setPublishTemplate(false)
  }

  const handleDragEnd = (result) => {
    if(!result.destination) return
    const items = Array.from(btnCallToAction)
    const [reorderData] = items.splice(result.source.index, 1)
    items.splice(result.destination.index,0, reorderData)
    setBtnCallToAction(items)

    if (publishTemplate) setPublishTemplate(false)
  }

  const validateTemplate = () => {
    if(nameTemplate === ''){
      setErrorTemplate({ nameTemplate: 'template_validation_field_name' })
      return false
    }
    if(headerTemplateValue.value ==='text' && nameHeaderTemplate === ''){
      setErrorTemplate({ nameHeaderTemplate: 'template_validation_field_header_text' })
      return false
    }

    if(headerTemplateValue.value ==='text' && varHeader && !varHeader.field){
      setErrorTemplate({ varHeader: 'template_validation_field_header_vars' })
      return false
    }

    if( ['image', 'video', 'document'].includes(headerTemplateValue.value) && !attachmentHeader){
      setErrorTemplate({ attachmentHeader: 'template_validation_field_header_attachment' })
      return false
    }
    if(attachmentHeader && attachmentHeader.length === 1 && attachmentHeader[0]?.mimeType === headerTemplateValue.value ==='image'){
      setErrorTemplate({ attachmentHeader:'template_validation_field_header_attachment_diferent_type' })
      return false
    }
    if(contentBody.value?.content === ''){
      setErrorTemplate({ contentBody:'template_validation_field_body' })
      return false
    }
    if(contentBody.value?.variablesEditor.length !== varBody.length){
      setErrorTemplate({ varBody:'template_validation_field_header_vars' })
      return false
    }
    if(buttonsTemplateValue.value === 'quick_reply' && (btnQuickReply.length === 0 || btnQuickReply.some((el) => el === ''))){
      setErrorTemplate({ btnQuickReply:'template_validation_field_quick_reply' })
      return false
    }
    if(buttonsTemplateValue.value === 'call_to_action' &&
      (btnCallToAction.length === 0 ||
      btnCallToAction.some((el) => (
        el.textBtn === '' || !el.textBtn || !el[el.type.value] || el[el.type.value] === '')))){
      setErrorTemplate({ btnCallToAction:'template_validation_field_quick_reply' })
      return false
    }
    return true
  }

  const saveTemplate = async () => {
    setIsLoading(true)
    const isValid = validateTemplate()
    if(isValid){
      const _template = {
        provider: 'whatsapp',
        channel: 'whatsapp',
        company:company._id,
        locale: languageTemplateValue.value,
        name: nameTemplate,
        content: contentBody.value?.content,
        contentHtml: contentBody.value?.contentHtml,
        variables: varBody,
        type: isChat ? 'CHAT' : 'CAMPAING'
      }

      if(headerTemplateValue && headerTemplateValue.value !=='none'){
        _template.header = {
          type : headerTemplateValue.value !=='text' ? 'media' : headerTemplateValue.value,
          format : (headerTemplateValue.value).toUpperCase()
        }
        if(headerTemplateValue.value !== 'text') _template.attachments = attachmentHeader
        if(headerTemplateValue.value === 'text'){
          _template.header.content = nameHeaderTemplate
          _template.header.variable = {}
          if(varHeader) _template.header.variable = {
            name: varHeader.name || varHeader.input,
            field: varHeader.field
          }
        }
      }

      if(footerTemplate) _template.footer = { content: footerTemplate }

      // eslint-disable-next-line default-case
      switch (buttonsTemplateValue.value) {
        case 'quick_reply':
          if (btnQuickReply && btnQuickReply.length > 0) {
            _template.buttons = []
            for(let btn of btnQuickReply)
              _template.buttons.push({ type:'postback', label:btn, content:btn })
          }
          break
        case 'call_to_action':
          if (btnCallToAction && btnCallToAction.length > 0) {
            _template.buttons = []
            for(let btn of btnCallToAction){
              let phoneValue = btn[btn.type.value]
              if(btn.type.value === 'phone') {
                if (phoneValue[0]!=='+') phoneValue = `+${phoneValue}`
              }

              _template.buttons.push({
                type:btn.type.value,
                label:btn.textBtn,
                content:phoneValue })
            }
          }
          break
      }

      try {
        let msgToast
        let templateId
        let newTemplate
        if(!template) {
          const data = await marketingAct.createTemplate(_template, isChat)(dispatch)
          const { existVirus, attachmentsVirus } = verifyFileVirus({ data: data, isOutbound: true })
          if(existVirus) {
            setAttachmentHeader(attachmentsVirus)
            return data
          }
          msgToast = 'template_created'
          if (data.template) {
            setTemplateReview(data.template)
            newTemplate = data.template
          }
          templateId = data.template._id
        } else {
          msgToast = 'template_updated'
          const data = await marketingAct.updateTemplate(template._id, _template, isChat)(dispatch)
          const { existVirus, attachmentsVirus } = verifyFileVirus({ data: data, isOutbound: true })
          if(existVirus) {
            setAttachmentHeader(attachmentsVirus)
            return data
          }
          if (data.template) {
            setTemplateReview(data.template)
            newTemplate = data.template
          }
          templateId = template._id
        }

        if (templateId && templateChannels?.length) {
          await addChannelsTemplate({
            templateId: templateId,
            channels: templateChannels.map(channel => ({
              channelId: channel.channelId, isEnabled: channel.isEnabled
            }))
          })
        }

        toast(I18n.t(msgToast), { position: 'top-center' })

        if (templateChannels?.length) {
          setPublishTemplate(needPublishTemplate({
            channels: templateChannels, template: newTemplate
          }))
        }

        if (setFormEdit) {
          setTimeout(() => {
            setForm({ isOpen: false })
            setFormEdit({
              isOpen: true,
              _id: templateId,
            })
          }, 1)
        }
      } catch(error) {
        toast(I18n.t(error.type), { position: 'top-center' })
      } finally {
        setIsLoading(false)
      }
    } else setIsLoading(false)
  }

  const reviewTemplate = () => {
    setIsLoadingReview(true)

    if(templateReview){
      const reviewTemplate = {
        templateId: templateReview._id,
        republish: statusPublish[`${templateReview.prevStatus}_${templateReview.status}`]
      }

      marketingAct.postPublishTemplate(reviewTemplate, isChat)(dispatch)
        .then(() => {
          setModalPublishedTemplate(true)
          setIsLoadingReview(false)
        })
        .catch(error => {
          if (error.error_user_msg) setModalPublishMessage(error.error_user_msg)
          setModalPublishedTemplate(true)
          setIsLoadingReview(false)
        })
    }
  }

  const togglePreviewModal = () => setIsOpenPreviewModal(!isOpenPreviewModal)

  return (
    <>
      <Form noValidate className='template-form-wrapper'>
        <Row className='template-form-content'>
          <Row style={{ width: '100%' }}>
            <Collapse isOpen={isOpenAlert} style={{ width: '100%' }}>
              <Row className='alert-message'>
                <Col sm={1} className={'img'}>
                  <img src='./img/icons/icon-warning.svg' alt={'alert'} width={'26px'} height={'22px'} />
                </Col>
                <Col sm={10} className={'text'}>
                  <p dangerouslySetInnerHTML={{ __html: _.replace(I18n.t('templates_copy_disclaimer_whatsapp1'), '##URL##', MARKETING.urlsTwillo.tutorial) }} />
                </Col>
                <Col sm={1} className={'icon'}>
                  <li className='fa fa-times' onClick={() => setIsOpenAlert(!isOpenAlert)} />
                </Col>
              </Row>
            </Collapse>
          </Row>
          <Row style={{ width: '100%' }}>
            <Col sm={12} xs={12} xl={7} className='mb-4 mt-2'>
              {/* Idioma */}
              <Row>
                <Col>
                  <FormGroup>
                    <Label className='text-input-label' >Idioma</Label>
                    <SelectWithLabel
                      name='languageTemplate'
                      key='languageTemplate'
                      options={languageTemplateOptions}
                      multi={false}
                      value={languageTemplateValue}
                      selectedValues={languageTemplateValue}
                      onChange={(value)=>onChange(value, 'language')}
                      classNameWrapper='iconText-selector'
                      className='select-label-container-width'
                      isDisabled={!!template?._id}
                    />
                  </FormGroup>
                </Col>
              </Row>
              {/* Nombre del template */}
              <Row>
                <Col>
                  <FormGroup>
                    <TextInputField
                      name='name'
                      id='name'
                      label={I18n.t('template_name')}
                      className='plugin-categories__search__input'
                      classNameWrapper='wrapper-plugin-categories__search__input'
                      value={nameTemplate}
                      onChange={(value) =>{
                        setNameTemplate(value.replace(/\s/, '_').replace(/[^\w]/ig, '').toLowerCase())
                        setErrorTemplate({ nameTemplate:'' })
                      }}
                      placeholder={lang('template_name_hint')}
                      maxCharacter={512}
                      disabled={!!template?._id}
                      autoFocus
                    />
                    {errorTemplate.nameTemplate && <span className='errorTemplate'>{I18n.t(errorTemplate.nameTemplate)}</span>}
                  </FormGroup>
                </Col>
              </Row>
              {/* Header */}
              <Row>
                <Col sm={6} xs={6} xl={7} className='mb-1 mt-2'>
                  <FormGroup>
                    <label className='text-input-label' >{lang('dashboard_header')} <small className='label-optional'>({lang('dashboard_optional')})</small> </label>
                    <SelectWithLabel
                      name='headerTemplate'
                      key='headerTemplate'
                      options={headerTemplateOptions}
                      multi={false}
                      value={headerTemplateValue}
                      selectedValues={headerTemplateValue}
                      onChange={(value)=>onChange(value, 'headerTemplate')}
                      classNameWrapper='iconText-selector select-label-container-width-template'
                      className='select-label-container-width'
                      isDisabled={disabledEdit}
                    />
                    {errorTemplate.attachmentHeader && <span className='errorTemplate'>{I18n.t(errorTemplate.attachmentHeader)}</span>}
                  </FormGroup>
                </Col>
                {(headerTemplateValue.value !== 'text' && headerTemplateValue.value !== 'none' && headerTemplateValue.value)&&
                  <Col style={{ marginLeft:-10 }} sm={6} xs={6} xl={5} className='mb-1 mt-4'>
                    {btnFile}
                  </Col>
                }

                {headerTemplateValue.value === 'text' &&
                  <>
                    <Col sm={12} className='mt-2'>
                      <TextInputField
                        name='header'
                        id='header'
                        label={''}
                        value={nameHeaderTemplate}
                        className='plugin-categories__search__input'
                        classNameWrapper='wrapper-plugin-categories__search__input'
                        onChange={(value) => onChangeHeaderTemplate(value)}
                        placeholder={''}
                        autoFocus
                        maxCharacter={60}
                        disabled={disabledEdit}
                      />
                      {errorTemplate.nameHeaderTemplate &&<span className='errorTemplate'>{I18n.t(errorTemplate.nameHeaderTemplate)}</span>}
                    </Col>
                    <Col sm={12} className='mb-4' style={{ textAlign:'right' }}>
                      <small className={`text-muted pointer variable `} onClick={onClickVariable}>
                        {`{{VAR}}`}
                      </small>
                    </Col>
                    {varHeader &&
                      <Col sm={12}>
                        <FormGroup>
                          <Label>{I18n.t('dashboard_variables')}</Label>
                          <ul className='variables'>
                            <li>
                              <Row>
                                <Col>
                                  <div className='code-wrapper w-20 float-left'>
                                    <code className='code-wrapper-var'>{`${varHeader.input}`}</code>:
                                  </div>
                                  <div className='w-80 float-right'>
                                    <Select
                                      id={`variable--${varHeader.index}`}
                                      name={`variable--${varHeader.index}`}
                                      onChange={(values) => handleVariableOnChangeHeader(values, varHeader.input)}
                                      options={varsOptions}
                                      styles={STYLES_REACT_SELECT_NEW_WITH_INSET_SHADOW}
                                      defaultValue={template ? getSelectVariableValueByIndex(varsOptions, varHeader.field) : ''}
                                    />
                                  </div>
                                  {errorTemplate.varHeader && <span className='errorTemplate'>{I18n.t(errorTemplate.varHeader)}</span>}
                                </Col>
                              </Row>
                            </li>
                          </ul>
                        </FormGroup>
                      </Col>
                    }
                  </>
                }
                {attachmentHeader &&
                  <Col sm={4} className='mb-4'>
                    <div className='preview_header'>
                      {headerTemplateValue.value !== 'text' && headerTemplateValue.value !== 'none' && attachmentHeader[0] &&
                        <>
                          <img className="icon_reset" src={getStaticImage('/icons/orange-brand/icon-close.svg')} alt="close" />
                          <div
                            style={{
                              border: attachmentHeader[0]?.withVirus ? '2px solid red' : 'none'
                            }}
                          >

                            <Attachment
                              url={attachmentHeader[0]?.url || attachmentHeader[0]?.urlLong}
                              mimeType={attachmentHeader[0]?.mimeType}
                              mimeSubtype={attachmentHeader[0]?.mimeSubtype}
                              shortUrl={attachmentHeader[0]?.url || attachmentHeader[0]?.shortUrl}
                              thumb={attachmentHeader[0]?.thumb}
                            />
                          </div>
                        </>
                      }
                    </div>
                  </Col>
                }
              </Row>
              {/* Body Template */}
              <Row>
                <Col>
                  <FormGroup>
                    <Label for='code' className='text-input-label'>
                      {I18n.t('template_content')}
                    </Label>
                    <TextEditor2
                      id={`content-whatsapp-whatsapp`}
                      cols={5}
                      rows={7}
                      value={contentBody.value?.content || ''}
                      company={company}
                      channel={channel}
                      variables={variables}
                      parent={isChat ? 'chat' : 'campaign'}
                      limit={0}
                      acceptTypes={isChat ? acceptTypes.chat : acceptTypes.marketing}
                      options={['emojis', 'preview']}
                      onPreviewMsg={togglePreviewModal}
                      onChange={messageData => onChangeBody({
                        type: 'message',
                        value: {
                          content: messageData.value,
                          contentHtml: messageData.valueHtml,
                          removeEmojisAndAccents: messageData.removeEmojisAndAccents,
                          variablesEditor: messageData.variables
                        }
                      })}
                      dropZoneFilesHeight={183}
                      isTemplateCheck
                      isTemplateValue={true}
                      maxHeight={null}
                      disableEditor={disabledEdit}
                    />
                    {errorTemplate.contentBody && <span className='errorTemplate'>{I18n.t(errorTemplate.contentBody)}</span>}
                  </FormGroup>
                </Col>
                {contentBody.value?.variablesEditor?.length > 0 && (
                  <Col sm={12}>
                    <FormGroup>
                      <Label for='code'>{I18n.t('dashboard_variables')}</Label>
                      <ul className='variables'>
                        {(contentBody.value?.variablesEditor || []).map((variablesName, index) => (
                          <li key={index}>
                            <Row>
                              <Col>
                                <div className='code-wrapper w-20 float-left'>
                                  <code className='code-wrapper-var'>{`{{${variablesName}}}`}</code>:
                                </div>
                                <div className='w-80 float-right'>
                                  <Select
                                    id={`variable--${index}`}
                                    name={`variable--${index}`}
                                    onChange={(value) => handleVariableOnChange(value, variablesName, index)}
                                    options={varsOptions}
                                    styles={STYLES_REACT_SELECT_NEW_WITH_INSET_SHADOW}
                                    defaultValue={template?.variables?.length ? getSelectVariableValueByIndex(varsOptions, template.variables[index]?.field): ''}
                                  />
                                </div>
                                {errorTemplate.varBody && <span className='errorTemplate'>{I18n.t(errorTemplate.varBody)}</span>}
                              </Col>
                            </Row>
                          </li>
                        ))}
                      </ul>
                    </FormGroup>
                  </Col>
                )}
              </Row>

              {/* Footer template */}
              <Row>
                <Col>
                  <FormGroup>
                    <label className='text-input-label' >{I18n.t('dashboard_message-footer')} <small className='label-optional'>({lang('dashboard_optional')})</small> </label>
                    <TextInputField
                      name='footer'
                      id='footer'
                      value={footerTemplate}
                      className='plugin-categories__search__input'
                      classNameWrapper='wrapper-plugin-categories__search__input'
                      onChange={(value) => setFooterTemplate(value)}
                      placeholder={''}
                      maxCharacter={60}
                      disabled={disabledEdit}
                    />
                  </FormGroup>
                </Col>
              </Row>

              {/* Buttons template */}
              <Row>
                <Col sm={12} xs={12} xl={12} className='mb-2 mt-2'>
                  <FormGroup>
                    <label className='text-input-label' >{I18n.t('dashboard_buttons')} <small className='label-optional'>({lang('dashboard_optional')})</small></label>
                    <SelectWithLabel
                      name='buttonsTemplate'
                      key='buttonsTemplate'
                      options={buttonsTemplateOptions}
                      multi={false}
                      value={buttonsTemplateValue}
                      selectedValues={buttonsTemplateValue}
                      onChange={(value)=>onChange(value, 'buttonsTemplate')}
                      classNameWrapper='iconText-selector'
                      className='select-label-container-width'
                      isDisabled={disabledEdit}
                    />
                  </FormGroup>
                  { buttonsTemplateValue.value === 'quick_reply' && (
                    <Row>
                      <Col sm={12} xl={12}>
                        {btnQuickReply.length < 1  && (
                          <Row>
                            <Col sm={11} className='mb-1 mt-1'>
                              <TextInputField
                                name='header'
                                id='header'
                                label={''}
                                value={btnQuickReply[0] || ''}
                                className='plugin-categories__search__input'
                                classNameWrapper='wrapper-plugin-categories__search__input'
                                onChange={(value) =>{
                                  btnQuickReply[0] = value
                                  setBtnQuickReply([...btnQuickReply])
                                }}
                                placeholder={lang('dashboard_call-me-example')}
                                autoFocus
                                maxCharacter={25}
                              />
                            </Col>
                          </Row>
                        )}
                        {btnQuickReply.length >= 0 && btnQuickReply.map((text, index) => (
                          (
                            <Row key={index}>
                              <Col sm={11} className='mb-1 mt-1'>
                                <TextInputField
                                  name='header'
                                  id='header'
                                  label={''}
                                  value={btnQuickReply[index]}
                                  className='plugin-categories__search__input'
                                  classNameWrapper='wrapper-plugin-categories__search__input'
                                  onChange={(value) =>{
                                    btnQuickReply[index] = value
                                    setBtnQuickReply([...btnQuickReply])
                                    setErrorTemplate({ btnQuickReply:'' })
                                  }}
                                  placeholder={lang('dashboard_call-me-example')}
                                  autoFocus
                                  maxCharacter={25}
                                />
                              </Col>
                              {
                                btnQuickReply.length > 1 && (
                                  <Col sm={1} style={{ display:'flex', padding:0 }}>
                                    <img className="icon_reset_btn" src={getStaticImage('/icons/orange-brand/icon-close.svg')} alt="close" onClick={() => resetBtnQuick(index)} />
                                  </Col>
                                )
                              }
                            </Row>
                          )
                        ))}
                        {errorTemplate.btnQuickReply &&
                          <Col>
                            <span className='errorTemplate'>{I18n.t(errorTemplate.btnQuickReply)}</span>
                          </Col>
                        }
                      </Col>
                      <Col sm={12} className='mt-2'>
                        {
                          btnQuickReply.length < 3 && (
                            <Row>
                              <Col sm={12}>
                                <a className='newBtnQuickReply' onClick={newButtonQuickReply}>
                                  <i className='fa fa-plus'></i>
                                  <span> {I18n.t('dashboard_add-another-button')}</span>
                                </a>
                              </Col>
                            </Row>
                          )
                        }
                      </Col>
                    </Row>
                  )}
                  {buttonsTemplateValue.value === 'call_to_action' &&(
                    <Row>
                      <Col sm={12} className='mb-2 mt-2'>
                        <DragDropContext onDragEnd={handleDragEnd}>
                          <Droppable droppableId='div'>
                            {(provided)=>(
                              <div
                                {...provided.droppableProps}
                                ref={provided.innerRef}
                              >
                                {!btnCallToAction.length ? null : btnCallToAction.map(({ type, textBtn, url='', phone='' }, index)=>(
                                  <Draggable key={index} draggableId={index.toString()} index={index}>
                                    {(provided)=>(
                                      <div
                                        {...provided.draggableProps}
                                        {...provided.dragHandleProps}
                                        elevation={2}
                                        ref={provided.innerRef}
                                        className='contentBtnCallToAction'
                                      >
                                        <div>...</div>
                                        <div className='detailsBtnCallToAction'>
                                          <Row>
                                            <Col sm={11} xl={10}>
                                              <Row>
                                                <Col sm={5} xs={5} xl={5}>
                                                  <FormGroup>
                                                    <Label className='text-input-label-call-to-action'>Tipo</Label>
                                                    <SelectWithLabel
                                                      name='languageTemplate'
                                                      key='languageTemplate'
                                                      options={btnCallToActionOptions}
                                                      multi={false}
                                                      value={type}
                                                      selectedValues={type || btnCallToActionOptionsValue}
                                                      onChange={(value)=>{
                                                        btnCallToAction[index].type = value
                                                        setBtnCallToAction([...btnCallToAction])
                                                        setBtnCallToActionOptionsValue(value)
                                                      }}
                                                      isDisabled={btnCallToAction.length === 2 ? true : false}
                                                      classNameWrapper='iconText-selector select-label-container-width-template select-label-btn-call-to-action'
                                                      className='select-label-container-width'
                                                    />
                                                  </FormGroup>
                                                </Col>
                                                <Col sm={7} xs={7} xl={6}>
                                                  <FormGroup>
                                                    <Label className='text-input-label-call-to-action'>{lang('dashboard_button-text')}</Label>
                                                    <TextInputField
                                                      name='name'
                                                      id='name'
                                                      className='plugin-categories__search__input'
                                                      classNameWrapper='wrapper-plugin-categories__search__input'
                                                      value={textBtn || ''}
                                                      onChange={(value) =>{
                                                        btnCallToAction[index].textBtn = value
                                                        setBtnCallToAction([...btnCallToAction])
                                                        setErrorTemplate({ btnCallToAction:'' })
                                                      }}
                                                      placeholder={lang('dashboard_text')}
                                                      autoFocus
                                                      maxCharacter={25}
                                                    />
                                                  </FormGroup>
                                                </Col>
                                                {type && type.value === 'url' && (
                                                  <Col sm={12}>
                                                    <FormGroup>
                                                      <Label className='text-input-label-call-to-action'>URL</Label>
                                                      <TextInputField
                                                        name='name'
                                                        id='name'
                                                        className='plugin-categories__search__input'
                                                        classNameWrapper='wrapper-plugin-categories__search__input'
                                                        value={url || ''}
                                                        onChange={(value) =>{
                                                          btnCallToAction[index].phone = ''
                                                          btnCallToAction[index].url = value
                                                          setBtnCallToAction([...btnCallToAction])
                                                          setErrorTemplate({ btnCallToAction:'' })
                                                        }}
                                                        placeholder={lang('dashboard_url')}
                                                        autoFocus
                                                        maxCharacter={2000}
                                                      />
                                                    </FormGroup>
                                                  </Col>
                                                )}
                                                {type && type.value === 'phone' && (
                                                  <Col sm={12} xl={10}>
                                                    <div className='seccion-fields'>
                                                      <Label className='text-input-label-call-to-action'>{lang('dashboard_phone-number')}</Label>
                                                      <PhoneInput
                                                        id='user_phone'
                                                        localization={es}
                                                        buttonClass='code_phone_btn'
                                                        country='es'
                                                        autoFormat
                                                        enableSearch
                                                        value={phone}
                                                        onChange={(value) => {
                                                          btnCallToAction[index].url = ''
                                                          btnCallToAction[index].phone = value.phone
                                                          setBtnCallToAction([...btnCallToAction])
                                                          setErrorTemplate({ btnCallToAction:'' })
                                                        }}
                                                      />
                                                    </div>
                                                  </Col>
                                                )}
                                              </Row>
                                            </Col>
                                            {
                                              btnCallToAction.length > 1 && (
                                                <Col sm={1} >
                                                  <img className="icon_reset_btn" src={getStaticImage('/icons/orange-brand/icon-close.svg')} alt="close" onClick={() => resetBtnCallToAction(index)} />
                                                </Col>
                                              )
                                            }
                                          </Row>
                                        </div>
                                      </div>
                                    )}
                                  </Draggable>
                                ))}
                                {provided.placeholder}
                              </div>
                            )}
                          </Droppable>
                        </DragDropContext>
                      </Col>
                      {errorTemplate.btnCallToAction &&
                        <Col>
                          <span className='errorTemplate'>{I18n.t(errorTemplate.btnCallToAction)}</span>
                        </Col>
                      }
                      <Col sm={12} className='mt-2'>
                        {
                          btnCallToAction.length < 2 && (
                            <Row>
                              <Col sm={12}>
                                <a className={`${btnCallToAction.length === 2 ? 'btnQuickReplyDisable': 'newBtnQuickReply'}`} onClick={newButtonCallToAction}>
                                  <i className='fa fa-plus'></i>
                                  <span> {I18n.t('dashboard_add-another-button')}</span>
                                </a>
                              </Col>
                            </Row>
                          )
                        }
                      </Col>
                    </Row>
                  )}
                </Col>
              </Row>
              <div className='template-form-content__template-channels'>
                {!isLoadingTemplateChannels ? (
                  <TemplateChannels
                    channel={channel}
                    channelsData={templateChannels}
                    templateChannels={templateChannels}
                    setTemplateChannels={setTemplateChannels}
                  />
                ) : (
                  <Nixi1Spinner width='25px' height='25px' />
                )}
              </div>
              <Row>
                <Col>
                  {(templateReview === null || templateReview?.status in statusEdit) &&
                    <Button color='btn btn-secondary' onClick={saveTemplate} disabled={publishTemplate}>
                      {isLoading ? <Nixi1Spinner width='1rem' height='1rem' /> : I18n.t('dashboard_save')}
                    </Button>
                  }
                  <Button color='btn btn-primary ml-2' onClick={reviewTemplate} disabled={!publishTemplate}>
                    {isLoadingReview ? <Nixi1Spinner width='1rem' height='1rem' /> : I18n.t('dashboard_request-review')}
                  </Button>
                  <Button outline color='btn btn-grey ml-2' onClick={() => setForm({ isOpen:false })}>
                    {I18n.t('dashboard_cancel')}
                  </Button>
                </Col>
              </Row>
            </Col>
            <Col sm={12} xs={12} xl={5}>
              <PhoneViewer
                variables={variables}
                channel={channel}
                company={company}
                textPreview={{
                  ...contentBody.value,
                  variables: contentBody?.value?.variables || [],
                  footer: footerTemplate,
                  textHeader:nameHeaderTemplate,
                  variablesHeader:varHeader,
                  attachments: attachmentHeader || [],
                  btnQuickReply,
                  buttons: btnCallToAction
                }}
                origin='marketing' />
            </Col>
          </Row>
        </Row>
      </Form>
      <ModalPublishedWATemplate
        isOpen={modalPublishedTemplate}
        toggle={() => {
          setModalPublishedTemplate(!modalPublishedTemplate)
          setForm({ isOpen:false })
        }}
        message={modalPublishMessage}
      />
      <ModalWrapper
        isOpen={isOpenPreviewModal}
        toggle={togglePreviewModal}
        header={I18n.t('dashboard_preview')}
        body={
          <div className='modal-content'>
            <PhoneViewer
              variables={variables}
              channel={channel}
              company={company}
              textPreview={{
                ...contentBody.value,
                variables: contentBody?.value?.variables || [],
                footer: footerTemplate,
                textHeader:nameHeaderTemplate,
                variablesHeader:varHeader,
                attachments: attachmentHeader || {},
                btnQuickReply,
                buttons: btnCallToAction
              }}
              origin='marketing' />
          </div>
        }
        eventBtnTxt={I18n.t('dashboard_close')}
        eventBtn={togglePreviewModal}
        contentClassName='modal-content-phone-preview'
      />
      {
        attachmentHeader && attachmentHeader?.length
          ? <ModalVirusAttachments attachments={attachmentHeader || []} />
          : null
      }
    </>
  )
}

export default FormWhatsappCloudApi